import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategories,
  addCategory,
  updateCategory,
  deleteCategory,
  clearCategoryMessages,
} from "../redux/slices/categorySlice";
import { toast } from "react-toastify";

const ManageCategory = () => {
  const dispatch = useDispatch();
  const { categories, loading, error, success } = useSelector(
    (state) => state.categories
  );

  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearCategoryMessages());
    }
    if (success) {
      toast.success(success);
      dispatch(clearCategoryMessages());
    }
  }, [error, success, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!categoryName.trim()) {
      toast.error("Category name is required");
      return;
    }

    const formData = new FormData();
    formData.append("name", categoryName.trim());        // ✅ correct field: name
    if (categoryImage) {
      formData.append("category_image", categoryImage);  // ✅ correct field: category_image
    }

    if (editId) {
      dispatch(updateCategory({ id: editId, formData }));
    } else {
      dispatch(addCategory(formData));
    }

    resetForm();
    document.getElementById("closeModalBtn").click();
  };

  const handleEdit = (category) => {
    setCategoryName(category.name);   // ✅ was category.categoryName (wrong)
    setCategoryImage(null);
    setEditId(category._id);          // ✅ was category.categoryId (wrong)
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      dispatch(deleteCategory(id));
    }
  };

  const resetForm = () => {
    setCategoryName("");
    setCategoryImage(null);
    setEditId(null);
  };

  return (
    <div className="container my-4">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Manage Categories</h5>
          <button
            className="btn btn-primary btn-sm"
            data-bs-toggle="modal"
            data-bs-target="#categoryModal"
            onClick={resetForm}
          >
            Add Category
          </button>
        </div>

        <div className="card-body">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.length > 0 ? (
                    categories.map((cat, index) => (
                      <tr key={cat._id}>
                        <td>{index + 1}</td>
                        <td>
                          {cat.category_image ? (     /* ✅ was cat.category_image (already correct in display, fixed consistency) */
                            <img
                              src={cat.category_image}
                              alt={cat.name}
                              width="50"
                              height="50"
                              style={{ objectFit: "cover", borderRadius: 4 }}
                            />
                          ) : (
                            <span className="text-muted">No Image</span>
                          )}
                        </td>
                        <td>{cat.name}</td>            {/* ✅ was cat.name (correct) */}
                        <td>
                          <button
                            className="btn btn-warning btn-sm me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#categoryModal"
                            onClick={() => handleEdit(cat)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(cat._id)}  /* ✅ was cat._id (correct) */
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No categories found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="categoryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editId ? "Edit Category" : "Add Category"}
                </h5>
                <button
                  type="button"
                  id="closeModalBtn"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={resetForm}
                />
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="e.g. Apartments"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Category Image
                    {editId && (
                      <small className="text-muted ms-1">(leave empty to keep existing)</small>
                    )}
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => setCategoryImage(e.target.files[0])}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={resetForm}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageCategory;
